import React from "react";
import { Card, CardContent, Typography, CircularProgress } from "@mui/material";
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { styled } from "@mui/material/styles";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useEffect } from "react";
import { useState } from "react";
import Grid from '@mui/material/Grid';
import renderPricingDetails from "../PricingDetails";
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import ComponentHeaderTitles from "../ComponentHeaderTitles";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';


const BestellingAanmaken = ({
    telefoonnummer,
    email,
    voornaam,
    achternaam,
    postcode,
    geboorteDatum,
    huisnummer,
    housenumberSuffix,
    chosenPakket,
    pricingDetailsComponent,
    setTermsOfServiceAccepted,
    overstapDatum,
    setOverstapDatum,
    streetName,
    cityName,
    bedrijfsnaam,
    kvkNummer,
    betaalmethode,
    setBetaalmethode,

}) => {


    // Calculate the date that is 20 days from the current date
    const today = new Date();
    const twentyDaysFromNow = new Date(today);
    twentyDaysFromNow.setDate(today.getDate() + 20); // This will handle month rollover correctly

    // Format the date to YYYY-MM-DD for the input
    const minDate = twentyDaysFromNow.toISOString().split('T')[0];
    ;

    const [tosAccepted, setTosAccepted] = useState(false);

    const handleTosChange = (event) => {
        setTosAccepted(event.target.checked);
        // set setTermsOfServiceAccepted to empty string if not checked, otherwise set to "true"
        setTermsOfServiceAccepted(event.target.checked ? "true" : "");
    }

    const handleDateChange = (event) => {
        setOverstapDatum(event.target.value);
    };

    const handlePaymentMethodChange = (event) => {
        setBetaalmethode(event.target.value);
    };

    // Always set terms of service accepted to empty string when component mounts so that the user has to check the checkbox again
    useEffect(() => {
        setTermsOfServiceAccepted("");
        setOverstapDatum(overstapDatum ? overstapDatum !== "" ? overstapDatum : minDate : minDate);

    }, []);

    /**
     * Set the betaalmethode to "Factuur" when the component mounts if it is not set yet.
     */
    useEffect(() => {
        setBetaalmethode(betaalmethode ? betaalmethode !== "" ? betaalmethode : "Automatische incasso" : "Automatische incasso");
    }, []);




    /**
     * Returns an overview of the user's data.
     * @returns 
     */
    const GegevensOverzicht = () => {
        return (
            <div class="gegevens-overzicht">
                <Card>
                    <CardContent>
                        <Typography variant="h6" component="h2">
                            Je gegevens
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemText primary="Naam" secondary={`${voornaam} ${achternaam}`} />
                            </ListItem>


                            <ListItem>
                                <ListItemText primary="Geboortedatum" secondary={`${geboorteDatum}`} />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Telefoon" secondary={telefoonnummer} />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="E-mail" secondary={email} />
                            </ListItem>
                        </List>
                        {bedrijfsnaam && (
                            <Typography variant="h6" component="h2">
                                Bedrijfsgegevens
                            </Typography>
                        )}
                        {bedrijfsnaam && (
                            <List>
                                <ListItem>
                                    <ListItemText primary="Bedrijfsnaam" secondary={bedrijfsnaam} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="KvK-nummer" secondary={kvkNummer} />
                                </ListItem>
                            </List>
                        )}


                        <Typography variant="h6" component="h2">
                            Adresgegevens
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemText primary="Woonplaats" secondary={cityName} />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Straat" secondary={streetName} />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Postcode" secondary={postcode} />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Huisnummer" secondary={`${huisnummer}${housenumberSuffix ? ` ${housenumberSuffix}` : ''}`}
                                />
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            </div>
        )
    }


    return (
        <div>
            <ComponentHeaderTitles title="Overzicht van je gegevens" />
            <GegevensOverzicht
                voornaam={voornaam}
                achternaam={achternaam}
                geboorteDatum={geboorteDatum}
                telefoonnummer={telefoonnummer}
                email={email}
                postcode={postcode}
                huisnummer={huisnummer}
                housenumberSuffix={housenumberSuffix}
            // Add other necessary props here
            />
            <div class="pricing-details-test">
                <pricingDetailsComponent
                    product={chosenPakket}
                />
            </div>

            <div className="ik-wil-overstappen-per-react">
                <TextField
                    id="date"
                    label="IK WIL OVERSTAPPEN PER"
                    type="date"
                    value={overstapDatum}
                    onChange={handleDateChange}
                    sx={{ margin: 1 }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        min: minDate,
                    }}
                />
            </div>

            <div className="betaalmethode-select">
                <FormControl fullWidth>
                    <InputLabel id="betaalmethode-label">Betaalmethode</InputLabel>
                    <Select
                        labelId="betaalmethode-label"
                        id="betaalmethode"
                        value={betaalmethode}
                        label="Betaalmethode"
                        onChange={handlePaymentMethodChange}
                        sx={{ margin: 1 }}
                    >
                        <MenuItem value={'Factuur'}>Factuur</MenuItem>
                        <MenuItem value={'Automatische incasso'}>Automatische incasso</MenuItem>
                    </Select>
                </FormControl>
            </div>

            <FormControlLabel
                control={
                    <Checkbox
                        checked={tosAccepted}
                        onChange={handleTosChange}
                        name="tosAccepted"
                        color="primary"
                    />
                }
                label=" Ik verklaar hierbij de gegevens naar waarheid te hebben ingevuld en vraag hierbij vrijblijvend een offerte voor de aangegeven diensten aan."
            />
        </div>
    );

};

BestellingAanmaken.displayName = 'BestellingAanmaken';
export default BestellingAanmaken;
